import Typography from '@mui/material/Typography';
import Heading from './Heading.js';
import Hero from './Hero.js';
import WorkExperience from './WorkExperience.js';
import ArticleThumbnail from './articleThumbnail.js';
import './App.css';

const tagsGoog = ["#digitalbusiness", "#adtech", "#e-commerce", "#tech"];
const tagsGoogPm = ["#productmanagement", "#growth", "#digitalbusiness", "#adtech"];
const tagsCN = ["#adtech", "#productmanagement", "#digitalbusiness", "#front-end"];
const tagsWMG1 = ["#publicspeaking", "#digitalmarketing", "#cro", "#digitalbusiness"];
const tagsSM = ["#digitalmarketing", "#paidmedia", "#digitalbusiness"];
const tagsPG1 = ["#productmanagement", "#uxdesign", "#productstrategy"];
const tagsPG2 = ["#digitalmarketing", "#paidmedia", "#digitalbusiness"];
const tagsCE = ["#digitalbusiness", "#productdevelopment", "#productstrategy", "#digitalmarketing"];
const tagsSL = ["#digitalbusiness", "#digitalmarketing", "#productdevelopment", "#coding"];
const tagsWMG2 = ["#e-business", "#digitalservices", "#productstrategy", "#coding"];
const tagsSDU = ["#culturaldiversity", "#business", "#management", "#studyandliveabroad"];
const tagsUDG = ["#business", "#management", "#hospitality", "#languages"];

export default function Homepage() {
    let browserComp = navigator.vendor;
    if (browserComp !== "Apple Computer, Inc.") {
        return (
            <div className="App-body">
                <Hero />
                <Heading text="Projects"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fprojects%20icon%2060x60.avif?alt=media&token=521878cb-669b-46d2-8663-dff380e879de" />

                <ArticleThumbnail
                    imgUrl1="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fs_logo_512.jpg?alt=media&token=21234194-5a79-433f-98ee-167c132da6e2"
                    imgAlt1="sala-idea"
                    title1="The Sala App"
                    details1="An online platform for restaurants and consumers."

                    imgUrl2="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FES%20universe.jpeg?alt=media&token=1ecd5ff6-6f62-4c26-bce6-9be480730070"
                    imgAlt2="about-this-site"
                    title2="My Portfolio Site"
                    details2="A site where to showcase my professional background and share content I care about."

                    imgUrl3="empty"
                    imgAlt3="es"
                    title3="es"
                    details3="es"
                />

                <Heading text="About me"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fman-raising-hand-type.avif?alt=media&token=4e08beb7-0c9b-4c91-9dad-098281abecec" />

                <Typography className="heading">
                    I am a digital business professional pursuing a career within the adtech and e-commerce industry at Google. My drive for growth is coupled by a deep academic knowledge of digital business management and strong technical experience in media and tech. I am an ambitious individual with a passion for building, improving and marketing digital and technology products that make users’ lives easier.
                </Typography>

                <Heading text="Experience"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fmale-technologist.avif?alt=media&token=bbde5ced-a178-4a64-b5a0-3242f626646a" />

                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fgoog%20img.avif?alt=media&token=4b4bf3e0-26ee-4b87-b263-42edced03157"
                    logoAlt="Google"
                    location="London, UK"
                    date="Mar '24 - Now"
                    title="Product Manager - Google"
                    details="Leading the Local Inventory Ads growth initiative focused on onboarding growth via Sales, and revenue growth by upselling existing clients via self-implementation."
                    tags={tagsGoogPm} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fgoog%20img.avif?alt=media&token=4b4bf3e0-26ee-4b87-b263-42edced03157"
                    logoAlt="Google"
                    location="London, UK"
                    date="Jan '22 - Now"
                    title="Senior Ads Solutions Architect - Google"
                    details="Providing specialized technical consulting and solution architecture support to Google's e-commerce customers. Building robust processes, systems, tools and documentation to ensure such cutting-edge products can eventually be serviced by generalists."
                    tags={tagsGoog} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwmg-logo.avif?alt=media&token=cc2028d8-6c84-450e-b2f6-e62ca2449654"
                    logoAlt="University of Warwick"
                    location="Coventry, UK"
                    date="May '19 - Now"
                    title="Guest Lecturer - University of Warwick"
                    details="Teaching masters-level lectures on CRO, Paid Marketing and e-Collaboration at the eCommerce, Digital Marketing and The Digital Workplace modules for students of the MSc in e-business management."
                    tags={tagsWMG1} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fconde-nast-logo.png?alt=media&token=6f62d1d7-95b3-4081-b07c-f9c5fd3b0965"
                    logoAlt="Condé Nast"
                    location="London, UK"
                    date="Mar '20 - Jan '22"
                    title="Ad Platform Specialist - Condé Nast"
                    details="Partnered with PMs and EMs from global product teams to prioritize, scope, groom and resolve key issues, features and A/B tests to boost platform monetization and product quality. Investigated and communicated strategic issues from adtech and commercial perspectives influencing monetization and migrations global product teams’ decisions."
                    tags={tagsCN} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fstarcom-logo.avif?alt=media&token=1191dbc0-9bf3-4ae5-bfbd-6fa4cc1e5d58"
                    logoAlt="Starcom Mediavest"
                    location="London, UK"
                    date="Sep '19 - Mar '20"
                    title="Senior Biddable Executive - Starcom Mediavest"
                    details="Responsible for media activation across Google, Microsoft, Amazon, Criteo and Facebook advertising; owning strategic and operational recommendations, project managing contact with the client."
                    tags={tagsSM} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpush-logo.avif?alt=media&token=390cca1a-dc39-4a15-94af-1806fe7f696b"
                    logoAlt="Push Group"
                    location="London, UK"
                    date="Mar '19 - Sep '19"
                    title="Junior Product Owner - Push Group"
                    details="Worked alongside the CEO building a web-based ad-tech product until beta version; contributed with product strategy, feature scoping, roadmap planning, backlog prioritisation and UX design."
                    tags={tagsPG1} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpush-logo.avif?alt=media&token=390cca1a-dc39-4a15-94af-1806fe7f696b"
                    logoAlt="Push Group"
                    location="London, UK"
                    date="Sep '18 - Sep '19"
                    title="Digital Account Manager - Push Group"
                    details="Led strategy and operations of an e-commerce portfolio of clients across Google and Microsoft Ads; line managed and mentored various junior team members reinforcing their digital knowledge."
                    tags={tagsPG2} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fexcetera-logo.avif?alt=media&token=fdcc004a-3454-485f-a058-b55b55aaef9a"
                    logoAlt="Excetera Group"
                    location="London, UK"
                    date="Feb '17 - Aug '17"
                    title="IT and Marketing Assistant - Excetera Group"
                    details="Planned, designed and built a SharePoint intranet from scratch that automated 20% of the workshop, procurement and reservations processes. Assisted with Google Ads optimisation and CMS content management."
                    tags={tagsCE} />

                <Heading text="Education"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fgraduation-cap.avif?alt=media&token=c0debe31-0cb5-4a97-9dd1-bb119452970e" />

                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fedu2.avif?alt=media&token=fdf1f5d4-2873-40a5-969b-a890ea6d4a2b"
                    logoAlt="Edu Image"
                    location="Everywhere"
                    date="- Always"
                    title="Self Learner -  From each job, class, book, article, co-worker and experience"
                    details="This is how I learned the majority of what I know; by reading, researching, learning and doing."
                    tags={tagsSL} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwmg-logo.avif?alt=media&token=cc2028d8-6c84-450e-b2f6-e62ca2449654"
                    logoAlt="University of Warwick"
                    location="Coventry, UK"
                    date="Aug'17 - Aug'18"
                    title="MSc e-Business Management Student - University of Warwick"
                    details="Check my MSc’s dissertation here. Here is where I developed a thorough understanding of:"
                    tags={tagsWMG2} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FSDU-logo.avif?alt=media&token=152abdb3-84d4-4c54-8b5a-a9a0f8288790"
                    logoAlt="University of Southern Denmark"
                    location="Esbjerg, Denmark"
                    date="Aug'13 - Feb'14"
                    title="Exchange program - University of Southern Denmark"
                    details="Exchange (ERASMUS) student. Here is where I learnt:"
                    tags={tagsSDU} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FUDG-logo.avif?alt=media&token=4322ed2b-106a-468b-bb19-2510ba17a16e"
                    logoAlt="University of Girona"
                    location="Girona, Spain"
                    date="Sep'11 - Jan'16"
                    title="BSc Hospitality Management Student - University of Girona"
                    details="Studied my bachelors degree in the 2nd best Hospitaliy University in Spain. Here is where I learnt:"
                    tags={tagsUDG} />

                <Heading text="Recent articles"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpage-with-curl.avif?alt=media&token=9af6c267-55d6-42f8-8405-08a76d6179db" />

                <ArticleThumbnail
                    imgUrl1="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Frest-tech.avif?alt=media&token=a199799c-cb74-4243-bc48-9b70a6743ead"
                    imgAlt1="sala-idea"
                    title1="The Sala Idea"
                    details1="A sneak peak at my thoughts about the future of the restaurant industry."

                    imgUrl2="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwebpage-feature-image.png?alt=media&token=8255e735-4919-423c-8c00-ef8fb421c53f"
                    imgAlt2="about-this-site"
                    title2="About This Site"
                    details2="Purpose and vision of the website, from a simple idea to the end product."

                    imgUrl3="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fcareer.avif?alt=media&token=ef22774f-0f08-48a7-b6bc-cde7460b5c01"
                    imgAlt3="your-dream-job"
                    title3="How to Get Your Dream Job"
                    details3="A systematic improvement approach towards getting your dream job."
                />

                <Heading text="Skills"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fhammer-and-wrench.avif?alt=media&token=20ed82b6-d3db-46a7-b7e8-11f8a3a96276" />

                <ArticleThumbnail
                    imgUrl1="null"
                    imgAlt1=""
                    title1="Programming"
                    details1="Working knowledge of HTML, CSS, JavaScript, React.js, React Native, SQL and Google Firebase."

                    imgUrl2="null"
                    imgAlt2=""
                    title2="Product management"
                    details2="Agile product management practitioner, Jira and Confluence advanced user."

                    imgUrl3="null"
                    imgAlt3=""
                    title3="Web analytics and tracking"
                    details3="Web tracking and analytics with Google analytics and tag manager."
                />
                <ArticleThumbnail
                    imgUrl1="null"
                    imgAlt1=""
                    title1="User experience and A/B testing"
                    details1="Conversion rate optimization and A/B testing with Hotjar and Google optimize."

                    imgUrl2="null"
                    imgAlt2=""
                    title2="Ad technology and ad servers"
                    details2="Ad servers with Google Ad Manager. Digital ads platforms technology."

                    imgUrl3="null"
                    imgAlt3=""
                    title3="Web development and optimization"
                    details3="Front-end website development and website speed optimization, FreeCodeCamp web design certified."
                />
            </div>
        )
    }

    else {
        return (
            <div className="App-body">
                <Hero />

                <Heading text="Projects"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fprojects%20icon%2060x60.png?alt=media&token=320b57ad-6b49-480a-9d2e-1b986cc07137" />

                <ArticleThumbnail
                    imgUrl1="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fs_logo_512.jpg?alt=media&token=21234194-5a79-433f-98ee-167c132da6e2"
                    imgAlt1="sala-idea"
                    title1="The Sala App"
                    details1="An online platform for restaurants and consumers."

                    imgUrl2="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FES%20universe.jpeg?alt=media&token=1ecd5ff6-6f62-4c26-bce6-9be480730070"
                    imgAlt2="about-this-site"
                    title2="My Portfolio Site"
                    details2="A site where to showcase my professional background and share content I care about."

                    imgUrl3="empty"
                    imgAlt3="es"
                    title3="es"
                    details3="es"
                />

                <Heading text="About me"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fman-raising-hand-type.png?alt=media&token=ffdc1fed-6b18-4202-8fc4-4bbf4892517d" />

                <Typography className="heading">
                    I am a digital business professional pursuing a career within the adtech and e-commerce industry at Google. My drive for growth is coupled by a deep academic knowledge of digital business management and strong technical experience in media and tech. I am an ambitious individual with a passion for building, improving and marketing digital and technology products that make users’ lives easier.
                </Typography>

                <Heading text="Experience"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fmale-technologist.png?alt=media&token=963e6cb3-d9dd-465a-b297-36332246c2c9" />

                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fgoog%20img.png?alt=media&token=abae0534-5851-471a-9271-ec7ba44bb422"
                    logoAlt="Google"
                    location="London, UK"
                    date="Jan'22 - Now"
                    title="Advertising Solutions Architect - Google"
                    details="Providing specialized technical consulting and solution architecture support to Google's e-commerce customers. Building robust processes, systems, tools and documentation to ensure such cutting-edge products can eventually be serviced by generalists."
                    tags={tagsGoog} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwmg-logo.png?alt=media&token=f910a2d0-e4bf-4050-83f5-5d7a1846ccb0"
                    logoAlt="University of Warwick"
                    location="Coventry, UK"
                    date="May'19 - Now"
                    title="Guest Lecturer - University of Warwick"
                    details="Teaching masters-level lectures on CRO, Paid Marketing and e-Collaboration at the eCommerce, Digital Marketing and The Digital Workplace modules for students of the MSc in e-business management."
                    tags={tagsWMG1} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fconde-nast-logo.png?alt=media&token=6f62d1d7-95b3-4081-b07c-f9c5fd3b0965"
                    logoAlt="Condé Nast"
                    location="London, UK"
                    date="Mar'20 - Jan'22"
                    title="Ad Platform Specialist - Condé Nast"
                    details="Partnered with PMs and EMs from global product teams to prioritize, scope, groom and resolve key issues, features and A/B tests to boost platform monetization and product quality. Investigated and communicated strategic issues from adtech and commercial perspectives influencing monetization and migrations global product teams’ decisions."
                    tags={tagsCN} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fstarcom-logo.png?alt=media&token=a2eeeeb2-3034-4f07-a27d-194c1fc25343"
                    logoAlt="Starcom Mediavest"
                    location="London, UK"
                    date="Sep'19 - Mar'20"
                    title="Senior Biddable Executive - Starcom Mediavest"
                    details="Responsible for media activation across Google, Microsoft, Amazon, Criteo and Facebook advertising; owning strategic and operational recommendations, project managing contact with the client."
                    tags={tagsSM} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpush-logo.jpeg?alt=media&token=6ba83c1b-1647-4aa9-b689-31fb97993dd0"
                    logoAlt="Push Group"
                    location="London, UK"
                    date="Mar'19 - Sep'19"
                    title="Junior Product Owner - Push Group"
                    details="Worked alongside the CEO building a web-based ad-tech product until beta version; contributed with product strategy, feature scoping, roadmap planning, backlog prioritisation and UX design."
                    tags={tagsPG1} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpush-logo.jpeg?alt=media&token=6ba83c1b-1647-4aa9-b689-31fb97993dd0"
                    logoAlt="Push Group"
                    location="London, UK"
                    date="Sep'18 - Sep'19"
                    title="Digital Account Manager - Push Group"
                    details="Led strategy and operations of an e-commerce portfolio of clients across Google and Microsoft Ads; line managed and mentored various junior team members reinforcing their digital knowledge."
                    tags={tagsPG2} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fexcetera-logo.png?alt=media&token=a3c0e5e0-f636-4a21-80ba-4da9acf26a3a"
                    logoAlt="Excetera Group"
                    location="London, UK"
                    date="Feb'17 - Aug'17"
                    title="IT and Marketing Assistant - Excetera Group"
                    details="Planned, designed and built a SharePoint intranet from scratch that automated 20% of the workshop, procurement and reservations processes. Assisted with Google Ads optimisation and CMS content management."
                    tags={tagsCE} />

                <Heading text="Education"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fgraduation-cap.png?alt=media&token=e744c368-b561-4bac-bca6-c810f8e3539d" />

                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fedu2.jpeg?alt=media&token=e11ff2ab-e734-4e4c-83d5-0093d0fe9e11"
                    logoAlt="Edu Image"
                    location="Everywhere"
                    date="- Always"
                    title="Self Learner -  From each job, class, book, article, co-worker and experience"
                    details="This is how I learned the majority of what I know; by reading, researching, learning and doing."
                    tags={tagsSL} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwmg-logo.png?alt=media&token=f910a2d0-e4bf-4050-83f5-5d7a1846ccb0"
                    logoAlt="University of Warwick"
                    location="Coventry, UK"
                    date="Aug'17 - Aug'18"
                    title="MSc e-Business Management Student - University of Warwick"
                    details="Check my MSc’s dissertation here. Here is where I developed a thorough understanding of:"
                    tags={tagsWMG2} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FSDU-logo.jpeg?alt=media&token=deb4dc39-8faa-46ee-8f9f-e0522b83e7d9"
                    logoAlt="University of Southern Denmark"
                    location="Esbjerg, Denmark"
                    date="Aug'13 - Feb'14"
                    title="Exchange program - University of Southern Denmark"
                    details="Exchange (ERASMUS) student. Here is where I learnt:"
                    tags={tagsSDU} />
                <WorkExperience
                    logo="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2FUDG-logo.png?alt=media&token=a9a0a2b2-58f3-4c2c-9b84-a66db8655433"
                    logoAlt="University of Girona"
                    location="Girona, Spain"
                    date="Sep'11 - Jan'16"
                    title="BSc Hospitality Management Student - University of Girona"
                    details="Studied my bachelors degree in the 2nd best Hospitaliy University in Spain. Here is where I learnt:"
                    tags={tagsUDG} />

                <Heading text="Recent articles"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fpage-with-curl.png?alt=media&token=ed787b88-3ad6-48e1-8122-b65051581f5c" />

                <ArticleThumbnail
                    imgUrl1="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Frest-tech.jpeg?alt=media&token=de3e9d7f-9422-40e4-965d-639917a79eb1"
                    imgAlt1="sala-idea"
                    title1="The Sala Idea"
                    details1="A sneak peak at my thoughts about the future of the restaurant industry."

                    imgUrl2="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fwebpage-feature-image.png?alt=media&token=8255e735-4919-423c-8c00-ef8fb421c53f"
                    imgAlt2="about-this-site"
                    title2="About This Site"
                    details2="Purpose and vision of the website, from a simple idea to the end product."

                    imgUrl3="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fcareer.jpeg?alt=media&token=db4d155d-ca73-42d1-b7c9-948760462379"
                    imgAlt3="your-dream-job"
                    title3="How to Get Your Dream Job"
                    details3="A systematic improvement approach towards getting your dream job."
                />

                <Heading text="Skills"
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/the-sala-app.appspot.com/o/ed_website_assets%2Fhammer-and-wrench.png?alt=media&token=c10592d3-0081-42c6-9b5a-653fb2c0d1a4" />

                <ArticleThumbnail
                    imgUrl1="null"
                    imgAlt1=""
                    title1="Programming"
                    details1="Working knowledge of HTML, CSS, JavaScript, React.js, React Native, SQL and Google Firebase."

                    imgUrl2="null"
                    imgAlt2=""
                    title2="Product management"
                    details2="Agile product management practitioner, Jira and Confluence advanced user."

                    imgUrl3="null"
                    imgAlt3=""
                    title3="Web analytics and tracking"
                    details3="Web tracking and analytics with Google analytics and tag manager."
                />
                <ArticleThumbnail
                    imgUrl1="null"
                    imgAlt1=""
                    title1="User experience and A/B testing"
                    details1="Conversion rate optimization and A/B testing with Hotjar and Google optimize."

                    imgUrl2="null"
                    imgAlt2=""
                    title2="Ad technology and ad servers"
                    details2="Ad servers with Google Ad Manager. Digital ads platforms technology."

                    imgUrl3="null"
                    imgAlt3=""
                    title3="Web development and optimization"
                    details3="Front-end website development and website speed optimization, FreeCodeCamp web design certified."
                />
            </div>
        )
    }
}